import { render, staticRenderFns } from "./CreatedEditAccessToken.vue?vue&type=template&id=7b972c51&scoped=true"
import script from "./CreatedEditAccessToken.vue?vue&type=script&lang=js"
export * from "./CreatedEditAccessToken.vue?vue&type=script&lang=js"
import style0 from "./CreatedEditAccessToken.vue?vue&type=style&index=0&id=7b972c51&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b972c51",
  null
  
)

export default component.exports